import React from "react";
import { Box, Button, Stack, Typography } from "@mui/material";
import { Eye, ArrowLeft2 } from "iconsax-react";
import { useAppDispatch, useAppSelector } from "@application/store/useStore";
import { stopImpersonation } from "@reducers/auth/slice/auth";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "@ui/utils/toaster";
import { useTranslation } from "react-i18next";
import userService from "@utility/user-service";
export const ImpersonationBanner = () => {
    var _a;
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const { impersonation, user } = useAppSelector((state) => state.auth);
    const { t } = useTranslation(["common"]);
    if (!impersonation.isImpersonating) {
        return null;
    }
    const handleStopImpersonation = () => {
        dispatch(stopImpersonation());
        toast.success(t("common:toasts.returnedToYourAccount"));
        navigate("/users");
    };
    const impersonatedUserName = (user === null || user === void 0 ? void 0 : user.name) || userService.getUserDisplayName() || "Unknown User";
    const originalUserName = ((_a = impersonation.originalUser) === null || _a === void 0 ? void 0 : _a.name) || "Your Account";
    // Check which page we're on to highlight the active navigation
    const isOnDashboard = location.pathname === "/dashboard" ||
        location.pathname.startsWith("/dashboard/");
    const isOnNodes = location.pathname === "/nodes" || location.pathname.startsWith("/nodes/");
    const isOnSettings = location.pathname === "/settings";
    return (React.createElement(Box, { sx: {
            position: "sticky",
            top: 0,
            zIndex: 1300,
            width: "100%",
            background: "linear-gradient(135deg, #FF6B35 0%, #F7931E 100%)",
            color: "white",
            py: 1.5,
            px: 3,
            boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
        } },
        React.createElement(Stack, { direction: { xs: "column", md: "row" }, alignItems: { xs: "flex-start", md: "center" }, justifyContent: "space-between", spacing: 2 },
            React.createElement(Stack, { direction: "row", alignItems: "center", spacing: 2 },
                React.createElement(Eye, { size: 24, variant: "Bold" }),
                React.createElement(Box, null,
                    React.createElement(Typography, { variant: "body2", sx: { fontWeight: 600, lineHeight: 1.2 } },
                        "Viewing as: ",
                        React.createElement("strong", null, impersonatedUserName)),
                    React.createElement(Typography, { variant: "caption", sx: { opacity: 0.9 } }, "You are viewing the dashboard as this user sees it"))),
            React.createElement(Stack, { direction: "row", spacing: 1, flexWrap: "wrap" }),
            React.createElement(Button, { variant: "contained", size: "small", startIcon: React.createElement(ArrowLeft2, { size: 18 }), onClick: handleStopImpersonation, sx: {
                    bgcolor: "white",
                    color: "#FF6B35",
                    fontWeight: 600,
                    textTransform: "none",
                    px: 2,
                    "&:hover": {
                        bgcolor: "rgba(255,255,255,0.9)",
                    },
                } },
                "Exit & Return to ",
                originalUserName))));
};
